function _typeof(a) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

function _classCallCheck(a, b) {
  if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(a, b) {
  for (var c, d = 0; d < b.length; d++) {
    c = b[d], c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(a, c.key, c);
  }
}

function _createClass(a, b, c) {
  return b && _defineProperties(a.prototype, b), c && _defineProperties(a, c), a;
}

function _possibleConstructorReturn(a, b) {
  return b && ("object" === _typeof(b) || "function" == typeof b) ? b : _assertThisInitialized(a);
}

function _getPrototypeOf(a) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, _getPrototypeOf(a);
}

function _inherits(a, b) {
  if ("function" != typeof b && null !== b) throw new TypeError("Super expression must either be null or a function");
  a.prototype = Object.create(b && b.prototype, {
    constructor: {
      value: a,
      writable: !0,
      configurable: !0
    }
  }), b && _setPrototypeOf(a, b);
}

function _setPrototypeOf(a, b) {
  return _setPrototypeOf = Object.setPrototypeOf || function (a, b) {
    return a.__proto__ = b, a;
  }, _setPrototypeOf(a, b);
}

function _assertThisInitialized(a) {
  if (void 0 === a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

import React from "react";
import GetCursorPosition from "cursor-position";

var ImageCrop =
/*#__PURE__*/
function (a) {
  function b() {
    var a;
    return _classCallCheck(this, b), a = _possibleConstructorReturn(this, _getPrototypeOf(b).call(this)), _defineProperty(_assertThisInitialized(_assertThisInitialized(a)), "response", function () {
      var b = document.getElementsByClassName("RICC")[0];
      if (!b) throw new Error("[ImageCrio] ImageCrop component not found.");
      var c = a.state.image,
          d = document.createElement("canvas"),
          e = b.getElementsByClassName("preview")[0].getElementsByTagName("img")[0],
          f = c.width / b.offsetWidth,
          g = c.height / b.offsetHeight;
      return 1 > f && (f = 1), 1 > g && (g = 1), d.width = a.state.cropSize.width * f, d.height = a.state.cropSize.height * g, d.getContext("2d").drawImage(e, -a.state.cropSize.x * f, -a.state.cropSize.y * g, c.width, c.height), {
        image: d.toDataURL(),
        data: {
          x: -a.state.cropSize.x * f,
          y: -a.state.cropSize.y * g,
          width: a.state.cropSize.width * f,
          height: a.state.cropSize.height * g
        }
      };
    }), _defineProperty(_assertThisInitialized(_assertThisInitialized(a)), "mouseDown", function (b) {
      var c = document.getElementsByClassName("RICC")[0];
      if (!c) throw new Error("[ImageCrio] ImageCrop component not found.");
      a.state.DEBUG && console.log("%c[RICC] Mouse down \u21A1", "color:#fff; background-color:#0097A7"), b.preventDefault(), document.addEventListener("mousemove", a.mouseMove), document.addEventListener("mouseup", a.mouseUp), document.addEventListener("touchmove", a.mouseMove), document.addEventListener("touchend", a.mouseUp);
      var d = "crop" === b.target.className,
          e = {
        x: 0,
        y: 0
      },
          f = GetCursorPosition({
        event: b,
        element: c
      }),
          g = f.x,
          h = f.y;
      d && (e = GetCursorPosition({
        event: b,
        element: c.getElementsByClassName("crop")[0]
      })), a.setState({
        activateCursorPosition: {
          x: g,
          y: h,
          xInCrop: e.x,
          yInCrop: e.y
        },
        cropVisibility: !0,
        moveAction: d,
        needToHide: !0
      });
    }), _defineProperty(_assertThisInitialized(_assertThisInitialized(a)), "mouseMove", function (b) {
      b.preventDefault();
      var c = 0,
          d = 0,
          e = document.getElementsByClassName("RICC")[0],
          f = GetCursorPosition({
        event: b,
        element: e
      }),
          g = f.x,
          h = f.y,
          i = g - a.state.activateCursorPosition.x,
          j = h - a.state.activateCursorPosition.y,
          k = {
        rightBottom: !1,
        rightTop: !1,
        leftBottom: !1,
        leftTop: !1
      };
      if (a.state.moveAction) return g -= a.state.activateCursorPosition.xInCrop, h -= a.state.activateCursorPosition.yInCrop, g + a.state.cropSize.width >= e.offsetWidth && (g = e.offsetWidth - a.state.cropSize.width), h + a.state.cropSize.height >= e.offsetHeight && (h = e.offsetHeight - a.state.cropSize.height), 0 > g && (g = 0), 0 > h && (h = 0), a.setState({
        cropSize: {
          x: g,
          y: h,
          width: a.state.cropSize.width,
          height: a.state.cropSize.height
        },
        needToHide: !1
      }), void (a.props.watch && a.props.watch(a.response()));

      if (0 < i && 0 < j && (k.rightBottom = !0), 0 < i && 0 > j && (k.rightTop = !0), 0 > i && 0 < j && (k.leftBottom = !0), 0 > i && 0 > j && (k.leftTop = !0), k.rightBottom) {
        a.state.DEBUG && console.log("%c[RICC] Mouse move \u2198", "color:#fff; background-color:#0097A7"), c = i, d = j;
        var l = a.state.activateCursorPosition;
        g = l.x, h = l.y, a.props.square && (d = c), a.state.activateCursorPosition.x + c > e.offsetWidth && (c = e.offsetWidth - a.state.activateCursorPosition.x, a.props.square && (d = c)), a.state.activateCursorPosition.y + d > e.offsetHeight && (d = e.offsetHeight - a.state.activateCursorPosition.y, a.props.square && (c = d));
      } else k.rightTop ? (a.state.DEBUG && console.log("%c[RICC] Mouse move \u2197", "color:#fff; background-color:#0097A7"), 0 > h && (h = 0), c = i, d = a.state.activateCursorPosition.y - h, g = a.state.activateCursorPosition.x, a.props.square && (c = d), a.state.activateCursorPosition.x + c > e.offsetWidth && (c = e.offsetWidth - a.state.activateCursorPosition.x, a.props.square && (d = c, h = a.state.activateCursorPosition.y - c))) : k.leftBottom ? (a.state.DEBUG && console.log("%c[RICC] Mouse move \u2199", "color:#fff; background-color:#0097A7"), 0 > g && (g = 0), c = a.state.activateCursorPosition.x - g, d = j, h = a.state.activateCursorPosition.y, a.props.square && (d = c), a.state.activateCursorPosition.y + d > e.offsetHeight && (d = e.offsetHeight - a.state.activateCursorPosition.y, a.props.square && (c = d), g = a.state.activateCursorPosition.x - d)) : k.leftTop && (a.state.DEBUG && console.log("%c[RICC] Mouse move \u2196", "color:#fff; background-color:#0097A7"), 0 > h && (h = 0), 0 > g && (g = 0), c = a.state.activateCursorPosition.x - g, d = a.state.activateCursorPosition.y - h, a.props.square && (-i <= -j ? (c = d, g = a.state.activateCursorPosition.x - c) : (d = c, h = a.state.activateCursorPosition.y - d)));

      a.setState({
        cropSize: {
          x: g,
          y: h,
          width: c,
          height: d
        },
        needToHide: !1
      }), a.props.watch && a.props.watch(a.response());
    }), _defineProperty(_assertThisInitialized(_assertThisInitialized(a)), "mouseUp", function (b) {
      a.state.DEBUG && console.log("%c[RICC] Mouse up \u2191", "color:#fff; background-color:#0097A7"), b.preventDefault(), document.removeEventListener("mousemove", a.mouseMove), document.removeEventListener("mouseup", a.mouseUp), document.removeEventListener("touchmove", a.mouseMove), document.removeEventListener("touchend", a.mouseUp);
      var c = a.state,
          d = c.cropSize,
          e = c.cropVisibility;
      a.state.needToHide && (a.props.onReset && a.props.onReset(!0), e = !1, d = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }), a.setState({
        cropSize: d,
        cropVisibility: e,
        moveAction: !1,
        activateCursorPosition: {
          x: 0,
          y: 0,
          xInCrop: 0,
          yInCrop: 0
        }
      }), a.props.onCrop && !a.state.needToHide && a.props.onCrop(a.response());
    }), _defineProperty(_assertThisInitialized(_assertThisInitialized(a)), "trackWindowResize", function () {
      var a = document.getElementsByClassName("RICC")[0],
          b = a.getElementsByClassName("preview")[0].getElementsByTagName("img")[0];
      b.style.width = "".concat(a.offsetWidth, "px"), b.style.height = "".concat(a.offsetHeight, "px");
    }), a.state = {
      DEBUG: !1,
      image: null,
      activateCursorPosition: {
        x: 0,
        y: 0,
        xInCrop: 0,
        yInCrop: 0
      },
      cropSize: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      },
      moveAction: !1,
      cropVisibility: !1,
      needToHide: !1
    }, a;
  }

  return _inherits(b, a), _createClass(b, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var a = this,
          b = document.getElementsByClassName("RICC")[0];
      if (!b) throw new Error("[ImageCrio] ImageCrop component not found.");
      var c = b.getElementsByClassName("image")[0],
          d = b.getElementsByClassName("preview")[0].getElementsByTagName("img")[0];
      this.props.maxWidth && (b.style.maxWidth = this.props.maxWidth || "0", c.style.maxWidth = this.props.maxWidth || "0"), this.props.maxHeight && (b.style.maxHeight = this.props.maxHeight || "0", c.style.maxHeight = this.props.maxHeight || "0");
      var e = new Image();
      e.src = this.props.src, e.onload = function () {
        d.style.width = "".concat(b.offsetWidth, "px"), d.style.height = "".concat(b.offsetHeight, "px"), a.setState({
          image: e
        });
      }, window.addEventListener("resize", this.trackWindowResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.trackWindowResize);
    }
  }, {
    key: "render",
    value: function render() {
      var a = {
        display: this.state.cropVisibility ? "block" : "none",
        top: "".concat(this.state.cropSize.y, "px"),
        left: "".concat(this.state.cropSize.x, "px"),
        width: "".concat(this.state.cropSize.width, "px"),
        height: "".concat(this.state.cropSize.height, "px")
      },
          b = {
        marginTop: "-".concat(this.state.cropSize.y, "px"),
        marginLeft: "-".concat(this.state.cropSize.x, "px")
      };
      return React.createElement("div", {
        className: "RICC",
        onTouchStart: this.mouseDown,
        onMouseDown: this.mouseDown
      }, React.createElement("div", {
        className: "crop",
        style: a
      }, React.createElement("div", {
        className: "preview"
      }, React.createElement("img", {
        className: "crop",
        src: this.props.src,
        style: b
      }))), React.createElement("div", {
        className: "background"
      }), React.createElement("img", {
        className: "image",
        src: this.props.src
      }));
    }
  }]), b;
}(React.Component);

_defineProperty(ImageCrop, "defaultProps", {
  src: "",
  square: !1,
  watch: !1,
  onCrop: function onCrop() {},
  onReset: function onReset() {}
});

export default ImageCrop;